import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import { Toaster } from "./components/ui/sonner";
import SmoothScroll from "./components/ui/SmoothScroll";
import CustomCursor from "./components/ui/CustomCursor";
import Preloader from "./components/ui/Preloader";
import { AnimatePresence } from "framer-motion";
import { clearAdminSession, isTokenValid } from "./lib/auth";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("admin_token");
  if (!isTokenValid(token)) {
    clearAdminSession();
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

const AppContent = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdmin && (
         <AnimatePresence mode="wait">
          {loading && <Preloader setLoading={setLoading} />}
        </AnimatePresence>
      )}

      {(!loading || isAdmin) && (
        <>
            {!isAdmin && <div className="noise-overlay" />}
            {!isAdmin && <CustomCursor />}
            
            {isAdmin ? (
               <Routes>
                  <Route path="/admin" element={<Navigate to="/admin/login" />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route 
                    path="/admin/dashboard" 
                    element={
                      <ProtectedRoute>
                        <AdminDashboard />
                      </ProtectedRoute>
                    } 
                  />
               </Routes>
            ) : (
              <SmoothScroll>
                  <Routes>
                      <Route path="/" element={<LandingPage />} />
                      <Route path="/blog" element={<BlogPage />} />
                      <Route path="/blog/:slug" element={<BlogPostPage />} />
                  </Routes>
              </SmoothScroll>
            )}
        </>
      )}
    </>
  );
}

function App() {
  return (
    <div className="App font-sans antialiased bg-background text-foreground min-h-screen">
       <BrowserRouter>
          <AppContent />
          <Toaster />
       </BrowserRouter>
    </div>
  );
}

export default App;
